module.exports = __webpack_public_path__ + "img/draw.1c3d2670.svg";